import apiUrl from '../../../../constants'
import axios from 'axios'
import {
	Validator
} from 'vee-validate'
import vSelect from 'vue-select'
import {
	BasicSelect
} from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import Loader from './../../shared/loader'
// import Vue from "vue";
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import download from 'downloadjs';
Vue.component("downloadExcel", JsonExcel)
export default {
	name: 'rackenquiry',
	components: {
		Loader,
		JsonExcel,
		download,
		BasicSelect
	},
	props: [],
	data() {
		return {
			isLoadingforxls: false,
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			csvFieldsForXls: {},
			listStockReportDataforxls: [],
			listStockReportDatacsv: [],
			productid: '',
			mrp: '',
			lotno: '',
			rackid: '',
			ProductName: '',
			ProductDescription: '',
			TotalStock: '',
			RackNo: '',
			isfoundID: '',
			isnotfoundID: '',
			isError: '',
			IDerrors: '',
			listData: [],
			stockerrors: '',
			listClientData: [],
			listWarehouseData: [],
			warehouse: '',
			client: '',
			ClientErr: '',
			WarehouseErr: '',
			ClientErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			formattedDate: '',
			isLoading: false,
			user_type: '',
			listsubinventoryData: [],
			subinventory: '',
			listMerchantData: [],
			merchantname: '',
			merchant: '',
			item: {},
			listMerchantData1: [],
			merchantList: [],
			clientid:'',
			warehouseid:''


		}
	},
	model: {
		totalCurrentStock: 0,
		totalRackStock: 0
	},
	computed: {
		totalCurrentStock: function() {
			return this.listData.reduce(function(totalCurrentStock, item) {
				return totalCurrentStock + parseFloat(item.whcurrentstock);
			}, 0);
		},
		totalRackStock: function() {
			return this.listData.reduce(function(totalRackStock, item) {
				return totalRackStock + parseFloat(item.whrackstock);
			}, 0);
		}
	},
	filters: {
		moment: function(date) {
			return moment(date).format('DD-MMM-YYYY');
		}
	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdbyID = userdetail.warehouseid;
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.warehouseid = '';
		this.user_type = userdetail.utype;
		this.reportname = this.$t('reports.rackEnquiryReport')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client;
		if(this.clientid!=='undefined'){
			this.getMerchantList();
			this.getsubinventoryList();
		}
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.getMerchantList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}

	},
	methods: {
		reset() {
			this.item = {}
		},
		onSelect(item) {
			this.item = item
			this.merchantname = item.value
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.isfoundID = '1'
			this.show = true;
			this.download = false;
			this.SearchRackForXls(3)
		},
		jsonToCSV(filename, data, csvfield, dateFilter = [], skipFilter = [], dataFilter) {
			var csvData = '';
			//Header
			if (this.title != null) {
				csvData += this.parseExtraData(this.title, '${data}\r\n')
			}
			//Fields
			csvData += ''
			Object.entries(dataFilter).forEach(([k, v]) => {
				csvData += k + ':' + v + ','
			})
			csvData += '\r\n'
			csvData += '\r\n'

			for (let key in data[0]) {
				if (skipFilter.indexOf(key) == -1)
					csvData += csvfield[key] + ',';
			}
			csvData = csvData.slice(0, csvData.length - 1);
			csvData += '\r\n';
			//Data
			data.map(function(item) {
				for (let key in item) {
					if (skipFilter.indexOf(key) == -1) {
						var escapedCSV = item[key] + ''; // cast Numbers to string
						if (escapedCSV.match(/[,"\n]/)) {
							escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
						}
						if (escapedCSV == 'null')
							csvData += ',';
						else {
							if (dateFilter.indexOf(key) != -1)
								csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ',';
							else
								csvData += escapedCSV + ',';
						}
					}
				}
				csvData = csvData.slice(0, csvData.length - 1);
				csvData += '\r\n';
			})
			//Footer
			if (this.footer != null) {
				csvData += this.parseExtraData(this.footer, '${data}\r\n');
			}
			filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
			return this.export(csvData, filename, "application/csv");
			return csvData;
		},
		export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		resetFlt() {
			this.show = false;
			this.download = true;
			if (this.user_type != "warehouse_user") {
				this.WarehouseErr = "";
				// this.warehouse = "";
			}
			this.isfoundID = '';
			this.client = "";
			this.rackid = "";
			document.getElementById("rackid").value = "";
			this.productid = "";
			document.getElementById("productid").value = "";
			this.stockerrors = "";
			this.IDerrors = "";
			this.ClientErr = "";
			this.listData = [];
			this.subinventory = '';
			this.merchantname = '';
			this.item = {
				value: '',
				text: ''
			};
			// this.listMerchantData1 = [{
			// 	value: '',
			// 	text: this.$t('common.selectMerchantPlaceHolder')
			// }];
			//this.$validator.reset();
		},
		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'merchantList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						this.item = {
							value: '',
							text: ''
						};
						this.listMerchantData1 = [{
							value: '',
							text: this.$t('common.merchantPlaceholder')
						}];
						this.listMerchantData.forEach(ele => {
							this.listMerchantData1.push({
								"value": ele.merchantid,
								"text": ele.merchantname
							})
						})

					}

				}, error => {
					console.error(error)
				})
		},
		getsubinventoryList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getSubInventoryList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listsubinventoryData = result.data;

					}
				}, error => {
					console.error(error)
				})
		},
		SearchRack(csvCheck = 0) {
			this.isfoundID = '';
			this.isnotfoundID = '';
			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.listData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.listData = [];
				return false;
			}
			if (this.rackid != '') {
				this.isLoading = true;
				var mrpPost = 0;
				if (this.mrp != '') {
					var mrpPost = this.mrp;
				}
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');
				this.input = ({
					'productid': this.productid,
					'rackid': this.rackid,
					'clientid': window.localStorage.getItem('selectedClient'),
					'merchantid': this.merchantname,
					'warehouseid': window.localStorage.getItem('selectedWarehouse'),
					'subinventory': this.subinventory,
					'csvData': csvCheck,
				})
				Object.entries(this.input).forEach(([k, v]) => {
					let skipkeys = ['offset', 'limit', 'csvData'];
					if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
						dataFilter[k] = v;
					}
				})
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getRackStockEnquiry',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						}
					})
					.then((response) => {
						if (csvCheck == 1) {
							if (response.data.data.length > 0) {
								this.show = true;
								this.download = false;
								this.listStockReportDataCsv = [];

								this.csvFields = {
									'productid': this.$t('common.productId'),
									'eancode': this.$t('inwardList.printData.productDetails.eanCode'),
									'mrp': this.$t('common.mrp'),
									'whcurrentstock': this.$t('daywiseatpstock.currentstock'),
									'whrackstock':  this.$t('reports.rackStock'),
									'subinventory':  this.$t('reports.inventory'),
									'rackid': this.$t('common.rackID'),
									'merchantname': this.$t('common.merchantName'),
									'racktype': this.$t('warehouseRacks.rackType'),
									'rackcapacity':this.$t('warehouseRacks.rackCapacity')
								};
								var dateFilder = [];
								var skipFilter = [];
								this.listStockReportDataCsv = response.data.data;
								this.jsonToCSV(this.$t('reports.rackEnquiryReport'), this.listStockReportDataCsv, this.csvFields, dateFilder, skipFilter, dataFilter);
							} else {
								if (result.data.status == true) {
									this.$alertify.success(this.$t('common.reportSizeError'));
								} else {
									this.$alertify.error(result.data.msg.message);
								}
							}
						}
						if (response.data.errorCode == 0) {
							this.listData = response.data.data;
							this.isfoundID = '1';
							this.isnotfoundID = '';
							this.isError = '';
							this.IDerrors = '';
							this.ClientErr = '';
							this.stockerrors = '';

						} else {
							this.isnotfoundID = '1';
							this.isfoundID = '';
							this.isError = '1';
							this.stockerrors = response.data.msg;
						}
					})
				this.isLoading = false;
			} else {
				this.isError = '1';
				this.IDerrors = this.$t('common.RackNoError');		
			}
		},
		SearchRackForXls(csvCheck = 0) {
			this.isfoundID = '1'
			this.isnotfoundID = '';
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.alertify.error(this.$t('srReport.clientError'));
				this.listData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.listData = [];
				return false;
			}
			if (this.rackid != '') {

				var mrpPost = 0;
				if (this.mrp != '') {
					var mrpPost = this.mrp;
				}
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');
				this.input = ({
					'productid': this.productid,
					'rackid': this.rackid,
					'clientid': window.localStorage.getItem('selectedClient'),
					'merchantid': this.merchantname,
					'warehouseid': window.localStorage.getItem('selectedWarehouse'),
					'subinventory': this.subinventory,
					'csvData': csvCheck,
				})
				Object.entries(this.input).forEach(([k, v]) => {
					let skipkeys = ['offset', 'limit', 'csvData'];
					if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
						value += k + ':' + v + ','
						this.dataFilter2 = str.concat(value);

					}
				})
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getRackStockEnquiry',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						}
					})
					.then((response) => {
						if (csvCheck == 3) {
							if (response.data.data.length > 0) {
								this.listReportDataforxls = [];
								this.csvFieldsForXls =[];
								 this.csvFieldsForXls[this.$t('common.productId')] = 'productid',
								 this.csvFieldsForXls[this.$t('inwardList.printData.productDetails.eanCode')] = 'eancode',
								 this.csvFieldsForXls[this.$t('common.mrp')]  = 'mrp',
								 this.csvFieldsForXls[this.$t('daywiseatpstock.currentstock')]  = 'whcurrentstock',
								 this.csvFieldsForXls[this.$t('reports.rackStock')]  = 'whrackstock',
								 this.csvFieldsForXls[this.$t('reports.inventory')]  = 'subinventory',
								 this.csvFieldsForXls[this.$t('common.rackID')]  =  'rackid',
								 this.csvFieldsForXls[this.$t('common.merchantName')]  =   'merchantname',
								 this.csvFieldsForXls[this.$t('warehouseRacks.rackType')]  = 'racktype',
								 this.csvFieldsForXls[this.$t('warehouseRacks.rackCapacity')]  =  'rackcapacity'
								this.listStockReportDataforxls = response.data.data;
							} else {
								if (result.data.status == true) {
									this.$alertify.success(this.$t('common.reportSizeError'));
								} else {
									this.$alertify.error(result.data.msg.message);
								}
							}


						}
					})

			} else {
				this.isError = '1';
				this.IDerrors = this.$t('common.RackNoError');
			}
		},
		// getClientList() {
		// 	this.listClientData = '';
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;
		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// getWarehouseList() {
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		// clientSelected() {
		// 	this.clientid = this.client;
		// 	if (this.clientid) {
		// 		this.getsubinventoryList();
		// 		this.getMerchantList();
		// 		this.merchantname = '';
		// 		this.getWarehouseList();
		// 		if (this.warehouseid) {
		// 			// this.SearchRack();
		// 		} else {
		// 			this.getWarehouseList();
		// 			this.getsubinventoryList();
		// 			this.getMerchantList();
		// 		}
		// 	}
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// console.log(this.warehouse);
		// 			// this.SearchRack();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		onSubmitForm: function() {
			this.$validator.validateAll().then(() => {
				console.log('form is valid')
			}).catch(() => {
				console.log('errors exist')
			});
		},
	}
}


// WEBPACK FOOTER //
// ./src/views/components/reports/rackenquiry/rackenquiry.component.js